import React from "react";
import { useNavigate } from "react-router-dom";
const AssigneeHistory = () => {
  const navigate = useNavigate();
  return (
    <div className="my-10">
      <h1 className="font-28-42-400">Assignee History</h1>

      <p
        className="font-18-400-24 flex items-center gap-2 cursor-pointer"
        onClick={() => navigate(-1)}
      >
        <img className="size-13 rotate--90" src="/Vector.svg" />
        Back
      </p>
    </div>
  );
};

export default AssigneeHistory;
